export default {"src":"/_next/static/media/beetx-smarts.01317dcc.svg","height":72,"width":72};